import React, { useState, useEffect, } from 'react'
import { Row, Col, Form, Button, InputGroup } from 'react-bootstrap'
import CampaignMenuExpress from './CampaignMenuExpress'
import TerminalMenuExpress from './TerminalMenu'
import { siteLinkUrl, siteImpactReportDict, siteEcfaLogoUrl } from 'modules/siteContents'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

library.add(fab)

export default class Footer extends React.Component {

  // state = {
  //   bigFont: false
  // }

  // Old version till Aug 30 2021
  // render() {
  //   const { bigFont } = this.state
  //   return (
  //     <div className="footer-container">
  //       {
  //         this.props.customer ? null : (
  //           <div className={`footer-upper p3 ${bigFont ? 'big-font' : ''}`}>
  //             <Row>
  //               <Col xs={12} sm={9}>
  //                 <Row>
  //                   <Col xs={6} sm={3}>
  //                     <h6>
  //                       <a href="/who-we-are">
  //                         WHO WE ARE
  //                       </a>
  //                     </h6>
  //                     <ul>
  //                       <li><a href={`${masterDomain}/staff`}>Meet The Staff</a></li>
  //                       <li><a href={`${masterDomain}/pro-life-meaning`}>Pro Life Meaning</a></li>
  //                       <li><a href={`${masterDomain}/in-the-news`}>In The News</a></li>
  //                     </ul>
  //                     <br />
  //                     <a href="https://analytics.excellenceingiving.com/overview/save-the-storks/" target="_blank" rel="noopener noreferrer">
  //                       <img src="https://savethestorks.org/wp-content/uploads/2018/10/Excellence-in-Giving-Certified-Transparent-200X200.png" width="125px" alt="excellence in giving" className="footer_logo" />
  //                     </a>
  //                     <br /><br />
  //                   </Col>
  //                   <Col xs={6} sm={3}>
  //                     <h6>
  //                       <a href={`${masterDomain}/what-we-do`}>
  //                         WHAT WE DO
  //                       </a>
  //                     </h6>
  //                     <ul>
  //                       <li><a href={`${masterDomain}/what-we-do/stork-bus-and-us/`}>Stork Bus and Us</a></li>
  //                       <li><a href={`${masterDomain}/what-we-do/stork-bus-locations/`}>Stork Bus Locations</a></li>
  //                       <li><a href={`${masterDomain}/what-we-do/advocacy-and-awareness/`}>Advocacy and Awareness</a></li>
  //                       <li><a href={`${masterDomain}/what-we-do/fundraise/`}>Fundraise</a></li>
  //                       <li><a href={`${masterDomain}/what-we-do/church/`}>Church</a></li>
  //                       <li><a href={`${masterDomain}/what-we-do/pregnancy-resource-center/`}>Pregnancy Resource Center</a></li>
  //                       <li><a href={`${masterDomain}/resources-for-women/`}>Resources For Women</a></li>
  //                     </ul>
  //                     <br />
  //                     <a href="https://www.guidestar.org/profile/46-1031815" target="_blank" rel="noopener noreferrer">
  //                       <img src="https://widgets.guidestar.org/gximage2?o=9250260&amp;l=v4" alt="gold seal of transparency" className="footer_logo" />
  //                     </a>
  //                     <br /><br />
  //                   </Col>
  //                   <Col xs={6} sm={3}>
  //                     <h6>
  //                       <a href={`${masterDomain}/join-the-movement/`}>
  //                         JOIN THE MOVEMENT
  //                       </a>
  //                     </h6>
  //                     <ul>
  //                       <li><a href={`${masterDomain}/advocate/`}>Advocate</a></li>
  //                       <li><a href={`${masterDomain}/careers/`}>Careers</a></li>
  //                       <li><a href={`${masterDomain}/volunteer/`}>Volunteer</a></li>
  //                       <li><a href={`${masterDomain}/volunteer-driver/`}>Volunteer Drivers</a></li>
  //                       <li><a href={`${masterDomain}/kirk-cameron/`}>Living Room Reset</a></li>
  //                       <li><a href={`${masterDomain}/flyway-conference/`}>Flyway Conference</a></li>
  //                       <li><a href={`${masterDomain}/march_for_life2020/`}>March For Life</a></li>
  //                     </ul>
  //                   </Col>
  //                   <Col xs={6} sm={3}>
  //                     <h6>BE INFORMED</h6>
  //                     <ul>
  //                       <li><a href={`${masterDomain}/subscribe/`}>E-mail Sign Up</a></li>
  //                       <li><a href={`${masterDomain}/contact-us/`}>Contact Us</a></li>
  //                       <li><a href={`${masterDomain}/blog/`}>Blog</a></li>
  //                       <li><a href={`${masterDomain}/store/`}>Store</a></li>
  //                       <li><a href={`${masterDomain}/unplanned/`}>Unplanned Movie</a></li>
  //                       <li><a href={`${masterDomain}/terms/`}>Terms & Conditions</a></li>
  //                       <li><a href={`${masterDomain}/privacy/`}>Privacy Policy</a></li>
  //                       <li><a href={`${masterDomain}/returns/`}>Return Policy</a></li>
  //                       <li><a href={`${masterDomain}/disclaimer/`}>Disclaimer</a></li>
  //                     </ul>
  //                     <br />
  //                     <span className="font_toggle" onClick={() => this.setState({ bigFont: !bigFont })}>
  //                       <img src={`${masterDomain}/wp-content/uploads/2020/02/icons8-lowercase-96_white.png`} width="30" alt="change font size" />
  //                     </span>
  //                   </Col>
  //                 </Row>
  //               </Col>
  //               <Col xs={12} sm={3}>
  //                 <Row>
  //                   <Col xs={12}>
  //                     <img src={`${masterDomain}/wp-content/uploads/2019/04/savethestorks_logo_footer.png`}/>
  //                     <br /><br />
  //                     <p>
  //                       Save the Storks exists to inspire cultural change by shaping compelling pro-life narratives and empowering strategic partners to serve and value every life
  //                     </p>
  //                   </Col>
  //                 </Row>
  //               </Col>
  //             </Row>
  //           </div>
  //         )
  //       }
  //       <div className="footer-lower">
  //         <Row>
  //           <Col xs={12} sm={9} className="footer-copyright">
  //             <div>© Copyright 2021. Save the Storks® is a 501 (c)(3) • EIN: 461031815</div>
  //             <div>
  //               <a href={`${masterDomain}/wp-content/uploads/2019/12/STS.2018.FS_.1.pdf`} target="_blank">
  //                 Audited Financial Report
  //               </a>
  //               &nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;&nbsp;
  //               <a href={`${masterDomain}/wp-content/uploads/2019/12/2018.STS_.990.Public.Copy_.pdf`} target="_blank">
  //                 2018 990
  //               </a>
  //               &nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;&nbsp;
  //               <a href={`${masterDomain}/wp-content/uploads/2020/04/Save_the_Storks_Impact_Report_2019.pdf`} target="_blank">
  //                 2019 Impact Report
  //               </a>
  //               &nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;&nbsp;
  //               <a href={`${masterDomain}/wp-content/uploads/2020/09/Midyear-impact-report-2020.pdf`} target="_blank">
  //                 2020 Mid-Year Impact Report
  //               </a>
  //             </div>
  //           </Col>
  //           <Col xs={12} sm={3}>
  //             <ul className="helpme-footer-social">
  //               <li>
  //                 <a target="_blank" href="https://www.facebook.com/SaveTheStorks">
  //                   <i className="helpme-icon-facebook" />
  //                 </a>
  //               </li>
  //               <li>
  //                 <a target="_blank" href="https://twitter.com/savethestorks">
  //                   <i className="helpme-icon-twitter" />
  //                 </a>
  //               </li>
  //               <li>
  //                 <a target="_blank" href="http://www.pinterest.com/savethestorks">
  //                   <i className="helpme-icon-pinterest" />
  //                 </a>
  //               </li>
  //               <li>
  //                 <a target="_blank" href="http://instagram.com/savethestorks">
  //                   <i className="helpme-icon-instagram" />
  //                 </a>
  //               </li>
  //               <li>
  //                 <a target="_blank" href="https://www.linkedin.com/company/save-the-storks/">
  //                   <i className="helpme-icon-linkedin" />
  //                 </a>
  //               </li>
  //               <li>
  //                 <a target="_blank" href="https://www.youtube.com/channel/UCYu5nomth5OqTOspTyJp0Yg">
  //                   <i className="helpme-icon-youtube" />
  //                 </a>
  //               </li>
  //             </ul>
  //           </Col>
  //         </Row>
  //       </div>
  //     </div>
  //   )
  // }

  render() {
    const { site, isAdminTerminal, stripeTerminals, initialUrlParams, layoutConfig } = this.props
    const masterDomain = siteLinkUrl[site]
    if (layoutConfig?.footer === false) {
      return null
    }
    switch(site) {
      case 'VV':
        return (
          <div className='footer-wrapper pt1 pb3'>
					  <Row>
							<Col xs={6}>
								<div className='pl3'>
                  <div>
                    <h3 className='mt3'>Mama Bear Care</h3>
                    <div>
                      <ul id="menu-about-us-footer">
                        <li id="menu-item-21">
                          <a href={`${masterDomain}/who-we-are/`}>Who We Are</a>
                        </li>
                        <li id="menu-item-681">
                          <a href={`${masterDomain}/join-the-village/`}>Join Mama Bear Care</a>
                        </li>
                        <li id="menu-item-709">
                          <a href={`${masterDomain}/resources/`}>Helpful Resources</a>
                        </li>
                        <li id="menu-item-710">
                          <a href={`${masterDomain}/contact/`}>Contact Us</a>
                        </li>
                        <li id="menu-item-45">
                          <a href={`${masterDomain}/blog/`}>Blog</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>							
              </Col>
							<Col xs={6}>
						    <nav className='pr3 mt3 footer-social'>
							    <ul>
								    <li>
                      <a href="https://www.facebook.com/VeritysVillage/">
                        <svg aria-hidden="true" role="img" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 2C6.5 2 2 6.5 2 12c0 5 3.7 9.1 8.4 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.3v7C18.3 21.1 22 17 22 12c0-5.5-4.5-10-10-10z"></path>
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/veritys_village/">
                        <svg aria-hidden="true" role="img" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12,4.622c2.403,0,2.688,0.009,3.637,0.052c0.877,0.04,1.354,0.187,1.671,0.31c0.42,0.163,0.72,0.358,1.035,0.673 c0.315,0.315,0.51,0.615,0.673,1.035c0.123,0.317,0.27,0.794,0.31,1.671c0.043,0.949,0.052,1.234,0.052,3.637 s-0.009,2.688-0.052,3.637c-0.04,0.877-0.187,1.354-0.31,1.671c-0.163,0.42-0.358,0.72-0.673,1.035 c-0.315,0.315-0.615,0.51-1.035,0.673c-0.317,0.123-0.794,0.27-1.671,0.31c-0.949,0.043-1.233,0.052-3.637,0.052 s-2.688-0.009-3.637-0.052c-0.877-0.04-1.354-0.187-1.671-0.31c-0.42-0.163-0.72-0.358-1.035-0.673 c-0.315-0.315-0.51-0.615-0.673-1.035c-0.123-0.317-0.27-0.794-0.31-1.671C4.631,14.688,4.622,14.403,4.622,12 s0.009-2.688,0.052-3.637c0.04-0.877,0.187-1.354,0.31-1.671c0.163-0.42,0.358-0.72,0.673-1.035 c0.315-0.315,0.615-0.51,1.035-0.673c0.317-0.123,0.794-0.27,1.671-0.31C9.312,4.631,9.597,4.622,12,4.622 M12,3 C9.556,3,9.249,3.01,8.289,3.054C7.331,3.098,6.677,3.25,6.105,3.472C5.513,3.702,5.011,4.01,4.511,4.511 c-0.5,0.5-0.808,1.002-1.038,1.594C3.25,6.677,3.098,7.331,3.054,8.289C3.01,9.249,3,9.556,3,12c0,2.444,0.01,2.751,0.054,3.711 c0.044,0.958,0.196,1.612,0.418,2.185c0.23,0.592,0.538,1.094,1.038,1.594c0.5,0.5,1.002,0.808,1.594,1.038 c0.572,0.222,1.227,0.375,2.185,0.418C9.249,20.99,9.556,21,12,21s2.751-0.01,3.711-0.054c0.958-0.044,1.612-0.196,2.185-0.418 c0.592-0.23,1.094-0.538,1.594-1.038c0.5-0.5,0.808-1.002,1.038-1.594c0.222-0.572,0.375-1.227,0.418-2.185 C20.99,14.751,21,14.444,21,12s-0.01-2.751-0.054-3.711c-0.044-0.958-0.196-1.612-0.418-2.185c-0.23-0.592-0.538-1.094-1.038-1.594 c-0.5-0.5-1.002-0.808-1.594-1.038c-0.572-0.222-1.227-0.375-2.185-0.418C14.751,3.01,14.444,3,12,3L12,3z M12,7.378 c-2.552,0-4.622,2.069-4.622,4.622S9.448,16.622,12,16.622s4.622-2.069,4.622-4.622S14.552,7.378,12,7.378z M12,15 c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S13.657,15,12,15z M16.804,6.116c-0.596,0-1.08,0.484-1.08,1.08 s0.484,1.08,1.08,1.08c0.596,0,1.08-0.484,1.08-1.08S17.401,6.116,16.804,6.116z"></path>
                        </svg>
                      </a>
                    </li>
							    </ul>
						    </nav>
                <br /><br />
						    <div className='flex v-center'>
                  <div>
                    <img loading="lazy" src={`${masterDomain}/wp-content/uploads/2020/11/savethestorks_logo_footer.png`} width="40" height="38" alt="sts logo"/>
                    &nbsp;
                  </div>
                  <div>
                    <p>
                      Powered by <br/>
                      <a href="https://savethestorks.org/" target="_blank">Save the Storks</a>
                    </p>
                  </div>
                </div>					
              </Col>
				    </Row>
				  </div>
        )
      case 'FEW':
        return <FooterFEW {...this.props} />
      case 'IHH':
        return (
          <div className="footer" style={{
            background: 'linear-gradient(rgba(0, 0, 0, 0.59), rgba(0, 0, 0, 0.59)), url(/server/assets/images/footer-background.webp)',
            backgroundSize: 'cover',
            padding: 'calc(10vw - 16px)',
            paddingTop: 48,
            paddingBottom: 48,
            color: 'white',
          }}>
            <Row>
              <Col xs={12} sm={6}>
                <img
                  src="/server/assets/images/footer-brand.webp"
                  width={90}
                  height={77}
                />
              </Col>
              <Col xs={12} sm={6} className='right flex v-bottom end'>
                <a href="mailto:ihhministry@gmail.com">
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 16 16">
                    <rect x="1" y="1" style={{ fill:'white' }} width="14" height="14" rx="8" ry="8"></rect>
                    <path style={{ fill:'black' }} fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm3.5-3h9L8.707 8.793a1 1 0 0 1-1.414 0L3.5 5zM3 6l3.586 3.586a2 2 0 0 0 2.828 0L13 6v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6z"></path>
                  </svg>
                </a>
                &nbsp;
                <a href="https://www.facebook.com/InHisHandsMinistry">
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 16 16">
                    <rect x="1" y="1" style={{ fill: 'white'}} width="14" height="14" rx="8" ry="8"></rect>
                    <path style={{fill:'#3b5998', fillRule:"evenodd"}} d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8.567 4.437V8.085H9.77l.159-1.5h-1.36l.001-.75c0-.392.037-.602.6-.602h.75v-1.5H8.718c-1.444 0-1.952.728-1.952 1.952v.9h-.9v1.5h.9v4.352h1.801z"></path>
                  </svg>
                </a>
                &nbsp;
                <a href="https://www.instagram.com/in_his_hands_ministry">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 16 16">
                <rect x="1" y="1" style={{ fill: 'white'}} width="14" height="14" rx="8" ry="8"></rect>
                <g style={{fill:'#e95950', fillRule:"evenodd"}}>
                  <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-4.267c-1.158 0-1.304.005-1.759.026a3.12 3.12 0 0 0-1.035.198 2.09 2.09 0 0 0-.756.492 2.095 2.095 0 0 0-.493.756c-.106.271-.178.582-.198 1.036-.02.455-.026.6-.026 1.759 0 1.159.005 1.304.026 1.759.021.454.093.764.198 1.035.11.281.255.52.492.756.237.238.476.384.756.493.271.105.582.177 1.036.198.455.02.6.026 1.759.026 1.159 0 1.304-.005 1.759-.026.454-.02.764-.093 1.036-.198.28-.11.518-.255.755-.493.238-.237.383-.475.493-.755.105-.272.177-.582.198-1.036.02-.455.026-.6.026-1.759 0-1.159-.006-1.304-.026-1.76-.021-.453-.093-.764-.198-1.035a2.094 2.094 0 0 0-.493-.756 2.085 2.085 0 0 0-.755-.492c-.272-.105-.583-.177-1.037-.198-.455-.02-.6-.026-1.759-.026H8z"></path>
                  <path d="M7.618 4.502H8c1.14 0 1.275.004 1.725.025.416.019.641.088.792.147.199.077.34.17.49.319.15.15.242.291.32.49.058.15.127.376.146.792.02.45.025.585.025 1.724s-.004 1.274-.025 1.724c-.019.416-.088.641-.147.792-.077.199-.17.34-.319.49a1.32 1.32 0 0 1-.49.319c-.15.059-.376.128-.792.147-.45.02-.585.025-1.725.025-1.139 0-1.274-.005-1.724-.025-.416-.02-.641-.089-.792-.147-.2-.078-.341-.17-.49-.32a1.322 1.322 0 0 1-.32-.49c-.058-.15-.128-.376-.147-.792-.02-.45-.024-.585-.024-1.724 0-1.14.004-1.274.024-1.724.02-.416.089-.641.147-.792.077-.199.17-.341.32-.49.149-.15.29-.242.49-.32.15-.058.376-.128.792-.147.394-.018.546-.023 1.342-.024v.001zm2.66.709a.512.512 0 1 0 0 1.024.512.512 0 0 0 0-1.024zM8 5.809a2.191 2.191 0 1 0 0 4.382A2.191 2.191 0 0 0 8 5.81z"></path>
                  <path d="M8 6.578a1.422 1.422 0 1 1 0 2.844 1.422 1.422 0 0 1 0-2.844z"></path>
                </g>
                </svg>
                </a>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} sm={6}>
                <div style={{ fontSize: 12, opacity: 0.5 }}>
                  This form is protected by reCAPTCHA and the Google&nbsp;
                  <a rel="noreferrer noopener" href="https://policies.google.com/privacy" target="_blank">
                    Privacy Policy
                  </a>
                  &nbsp;and&nbsp;
                  <a rel="noreferrer noopener" href="https://policies.google.com/terms" target="_blank">
                    Terms of Service
                  </a>
                </div>
              </Col>
            </Row>
            
          </div>
        )
      case 'CF':
        return (
          <div className="footer">
            <div style={{ maxWidth: 800, margin: 'auto', textAlign: 'center' }}>
              <h1 style={{ width: 540, maxWidth: '100%', margin: 'auto' }}>
                <i>{`You opened new doors on a way to me becoming a mom`}</i>
              </h1>
              <br />
              <h5>
                {`"Jenna", a new mom`}
              </h5>
              <br /><br /><br /><br />
              <h1 style={{ fontFamily: 'museo-slab-w01-100' }}>
                {`Caring Families Pregnancy Services INC.`}
              </h1>
              <br />
              <h5>
                {`Caring Families is a faith-based 501(c)3 non-profit in Connecticut. We do not receive any state or federal funding, as we depend on the generosity of donors like you who want to bring help, hope and healing to the women of Connecticut faced with an unexpected pregnancy. Together we can make a difference by showing compassion to our community.`}
              </h5>
              <br /><br />
              <div>{'© 2025 by Caring Families Pregnancy Services INC. '}</div>
            </div>
          </div>
        )
      default:
        return (
          <div style={{ fontFamily: 'Gotham-Book, Arial, sans-serif !important' }}>
            <div className="bg-darkblue full-width" style={{ height: 40 }}/>
            <div className="footer-container full-width">
              <div className='flex' style={{ maxWidth: '90rem', margin: 'auto' }}>
                <div className='flex-1'>
                  {
                    isAdminTerminal ? null : (
                      <div style={{ lineHeight: 2 }}>
                        {/* <p className="footer-copyright" style={{ fontSize: 'small', fontWeight: 'normal' }}>
                        Thank you for your support of the mission and programs of Save the Storks. We will make every effort to ensure that gifts designated to support specific programs or activities will be used in accordance with your wishes. However, unless a gift is made expressly conditional, Save the Storks and its board will determine how to use your gift in a way that furthers the mission of the organization.
                        </p> */}
                        <p 
                          className="footer-copyright" 
                          style={{ marginBottom: 0, paddingBottom: 0, fontSize: 'small', fontWeight: 'normal', fontFamily: 'Gotham-Bold, Arial, sans-serif' }}
                        >
                          <strong>Footnotes:</strong>
                        </p>
                        <p className="footer-copyright" style={{ paddingBottom: 10, fontSize: 'small', fontWeight: 'normal' }}>
                          1, 2 - Research Study of the Pro-Life/Pro-Choice Cause (2019, May). Save the Storks. <br/>Retrieved from https://savethestorks.org/wp-content/uploads/2019/10/Onsite-Revised-Save-The-Storks-1.pdf 
                        </p>
                      </div>
                    )
                  }
                  <div style={{ marginRight: '2em' }}>
                    {`© Copyright ${(new Date()).getFullYear()} Save the Storks® is a 501(c)(3) • EIN: 461031815`}
                    <a href="#header" style={{ fontFamily: 'Gotham-Book, Arial, sans-serif', WebkitFontSmoothing: 'antialiased', float: 'right' }} className="right mb1">
                      <div style={{ fontWeight: 'normal' }} className="sm-invisible">To the top ↑</div>
                      <div style={{ fontWeight: 'normal' }} className="sm-visible">Top ↑</div>
                    </a>
                  </div>
                  <div className='mt2'>
                  {/* <a href={`${masterDomain}${siteImpactReportDict[site]}`} target="_blank" style={{ whiteSpace: 'nowrap' }}>2021 Mid-Year Impact Report</a>
                  <span className='separator'>{'    •    '}</span>
                  <a href={`${masterDomain}/wp-content/uploads/2021/03/impactreport-2020-hl-forweb.pdf`} target="_blank" style={{ whiteSpace: 'nowrap' }}>2020 Impact Report</a>
                  <span className='separator'>{'    •    '}</span>
                  <a href={`${masterDomain}/wp-content/uploads/2021/08/2020-STS-990-Public-Copy.pdf`} target="_blank" style={{ whiteSpace: 'nowrap' }}>2020 990</a>
                  <span className='separator'>{'    •    '}</span>
                  <a href={`${masterDomain}/wp-content/uploads/2021/08/STS-2020-Audited-Financial-Statements.pdf`} target="_blank" style={{ whiteSpace: 'nowrap' }}>2020 Audited Financial Report</a>
                  <span className='separator'>{'    •    '}</span>
                  <a href={`${masterDomain}/wp-content/uploads/2021/03/2019.STS_.990.Public.pdf`} target="_blank" style={{ whiteSpace: 'nowrap' }}>2019 990</a>
                  <span className='separator'>{'    •    '}</span>
                  <a href={`${masterDomain}/terms-2`} target="_blank" style={{ whiteSpace: 'nowrap' }}>Terms</a>
                  <span className='separator'>{'    •    '}</span>
                  <a href={`${masterDomain}/privacy`} target="_blank" style={{ whiteSpace: 'nowrap' }}>Privacy</a>
                  { isAdminTerminal && <span className='separator'>{'    •    '}</span> } */}
                  { isAdminTerminal && <CampaignMenuExpress dropup={true} className="guest-mode footer-dropdown" initialUrlParams={initialUrlParams} />}
                  { isAdminTerminal && !!stripeTerminals.length && <span className='separator'>{'    •    '}</span> }
                  { isAdminTerminal && <TerminalMenuExpress dropup={true} className="guest-mode footer-dropdown" initialUrlParams={initialUrlParams} />}
                  </div>
                </div>
              </div>
              <div className='badge-container center flex v-center mt1' style={{ maxWidth: '90rem', margin: 'auto', justifyContent: 'center', flexWrap: 'wrap' }}>
                <a href='https://www.ecfa.org/MemberProfile.aspx?ID=53345' target='_blank'>
                  <img alt="" src={siteEcfaLogoUrl[site]} width={81} height={81} className="mb1 flex-1"/>
                </a>
                &nbsp;
                <a href="https://workplaces.org/articles/241-organizations-honored-as-certified-best-christian-workplaces-in-2022" target='_blank'>
                  <img alt="" src="https://donate.savethestorks.org/images/best-christian-workplaces.png" width={90} height={81} className="mb1 flex-1"/>
                </a>
                &nbsp;
                <a href="https://www.charitynavigator.org/ein/461031815" target='_blank'>
                  <img alt="" src="https://donate.savethestorks.org/images/Four-Star-Rating-Badge-Full-Color.png" width={90} height={81} className="mb1 flex-1" />
                </a>
                &nbsp;
                <a href="https://www.guidestar.org/profile/46-1031815" target='_blank'>
                  <img alt="" src="https://donate.savethestorks.org/images/candid-seal-platinum-2025.png" width={90} height={81} className="mb1 flex-1" />
                </a>
                &nbsp;
                <a href="https://greatnonprofits.org/org/save-the-storks?search=save%20the%20storks" target='_blank'>
                  <img alt="" src="https://donate.savethestorks.org/images/greatnonprofits.png" width={150} height={70}/>
                </a>
                &nbsp;
                <div className='flex v-center'>
                  <a href="https://db.ministrywatch.com/ministry.php?ein=461031815" target='_blank'>
                    <img alt="" src="https://donate.savethestorks.org/images/ministry-watch-1C-logo-1-e1710520853768.webp" width={150} height={36}/>
                  </a>
                  &nbsp;
                  <a href="https://analytics.excellenceingiving.com/overview/save-the-storks/" target='_blank'>
                    <img alt="" src="https://donate.savethestorks.org/images/EIG-Certified-Transparent-Logo.png" width={81} height={81}/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        )
    }
  }
}

const FooterFEW = ({ profileAuth0, navigate, serverSide, }) => {
  const isMobile = window.innerWidth <= 576

  const [hipaaImage, setHipaaImage] = useState(null)
  useEffect(() => {
    const retrieveImageUrl = async () => {
      try{
        const key = '28f05ae5-e619-4736-aa5b-3cf5f5e7e459'
        const baseUrl = 'https://cg-seals-prod.s3.amazonaws.com'
        const configUrl = `${baseUrl}/${key}/config.json`
        const configResponse = await fetch(configUrl, {
          method: 'GET',
          mode: 'cors',
          headers: { 'Accept': 'application/json', },
        })
        const config = await configResponse.json()
        setHipaaImage(`${baseUrl}/${key}/${config.seals[0]}`)
      } catch(e) {
        console.log(e)
      }
    }
    retrieveImageUrl()
  }, [])

  return (
    <div className="mt4 footer white position-relative" style={{ backgroundColor: '#2d3728', padding: 64 }}>
      <div className='border-overlap-top' style={{ backgroundColor: '#2d3728' }}/>
      <div
        className="flex flex-wrap"
        style={{ maxWidth: 1000, margin: 'auto' }}
      >
        <div className='flex-1'>
          <img style={{ display: 'block', marginBottom: 16 }} alt='For Every Woman' src={`/server/assets/images/Round-White-Logo.png`} width={isMobile ? 50 : 100}/>
          <a
            href="https://www.instagram.com/_foreverywoman"
            aria-label="Visit For Every Woman on Instagram"
            style={{ marginRight: 16 }}
            className="icon"
          >
            <FontAwesomeIcon icon="fa-brands fa-instagram" />
          </a>
          <a
            href="https://www.facebook.com/people/For-Every-Woman/61557347939916/"
            aria-label="Visit For Every Woman on Facebook"
            style={{ marginRight: 16 }}
            className="icon"
          >
            <FontAwesomeIcon icon="fa-brands fa-facebook-f" />
          </a>
          <a
            href="https://www.tiktok.com/@foreverywomancare"
            aria-label="Visit For Every Woman on TikTok"
            style={{ marginRight: 16 }}
            className="icon"
          >
            <FontAwesomeIcon icon="fa-brands fa-tiktok" />
          </a>
          <br /><br />
          <a href="mailto:info@foreverywoman.org" style={{ marginTop: 8 }}>
            <b>info@foreverywoman.org</b>
          </a>
          <br /><br />
        </div>
        <div 
          style={{ maxWidth: 240 }}
        >
          <Row>
            <Col
              xs={6}
              style={{ marginBottom: 16 }}
            >
              <a href="https://foreverywoman.org/blog">Blog</a>
            </Col>
            <Col
              xs={6}
              style={{ marginBottom: 16 }}
            >
              <a href="https://foreverywoman.org/get-involved">Get Involved</a>
            </Col>
            <Col
              xs={6}
              style={{ marginBottom: 16 }}
            >
              <a href="https://foreverywoman.org/search">Search Services</a>
            </Col>
            <Col
              xs={6}
              style={{ marginBottom: 16 }}
            >
              <a href="https://donate.foreverywoman.org">Donate</a>
            </Col>
            <Col
              xs={6}
              style={{ marginBottom: 16 }}
            >
              <a href="https://foreverywoman.org/resources">Resources</a>
            </Col>
            <Col
              xs={6}
              style={{ marginBottom: 16 }}
            >
              <a href="https://foreverywoman.org/mobile">Mobile</a>
            </Col>
            <Col
              xs={6}
              style={{ marginBottom: 16 }}
            >
              <a href="https://foreverywoman.org/partners">Partners</a>
            </Col>
          </Row>

          {hipaaImage &&
            <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 16,}}>
              <a aria-label='HIPAA Compliant' target={'_blank'} rel={'noopener noreferrer'} href={'https://compliancy-group.com/compliance-monitoring-dashboard/'}>
                <img
                  alt='HIPAA Compliant'
                  src={hipaaImage}
                  width={86}
                  height={'auto'}
                />
              </a>
            </div>
          }
        </div>
      </div>
      <hr />
      <br />
      <div className='flex flex-wrap h-between'>
        <span>{`© Copyright ${new Date().getFullYear()} For Every Woman® is a 501(c)(3)   EIN: 461031815`}</span>
        <span><a href="https://foreverywoman.org/privacy-policy">Privacy Policy</a></span>
        <span><a href="https://foreverywoman.org/disclaimer">Disclaimer</a></span>
        <span><a href="https://foreverywoman.org/return-policy">Return Policy</a></span>
      </div>
    </div>
  )
}
